import { jewlr_t } from "helpers/application"

export const reviewsData = [
  {
    sender: "Patricia, US",
    text:
      "This is an excellent company with amazing customer service. Sarah S has gone above and beyond to assist me with a return I have. She has been professional, and courteous and responds immediately. So hard to find this today!",
    title: "Exceptional Service…",
  },
  {
    sender: "Thomaz, US",
    text:
      "Excellent product quality. Our daughter loved it. It arrived earlier than expected. The box holding the ring was of superb quality. The card, everything—I loved it. You all do excellent work.",
    title: "Excellent Product Quality",
  },
  {
    sender: "Doreen, US",
    text:
      "Very easy to order online. Item was delivered fast and is beautiful. I forgot to enter my promo code at check out and emailed customer service. The issue was handled immediately. I will definitely order from them again.",
    title: "Very Easy to Order Online",
  },
  {
    sender: "FreedomisntFree, US",
    text: `I am a returning customer, and continue to be a returning customer because I continually receive great customer service and beautiful ${jewlr_t(
      "terms.jewelry"
    )} at a very good price. I will continue to be a returning customer.`,
    title: "Very Satisfied Again, as Usual!!",
  },
]
